import { Box, Grid, Button, Link } from "@mui/material";
import { ReactComponent as FayeIcon } from "../../icons/FayeLight.svg";
import GridPage from "components/layout/GridPage";
import useIsMobile from "components/hooks/useIsMobile";
import DocumentPage from "components/documents/DocumentPage";

export default () => {
  const isMobile = useIsMobile();

  return (
    <GridPage sx={{ padding: "0px" }}>
      <Grid
        container
        sx={{
          height: "72px",
          backgroundColor: "#FDFAF7",
          borderBottom: "1px solid #E8E8E8",
        }}
      >
        <Grid
          item
          xs={isMobile ? 6 : 8}
          sx={{ paddingLeft: isMobile ? "35px" : "70px" }}
        >
          <Box
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                color: "#FFFFFF",
                width: "100%",
                maxWidth: "750px",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                "& svg path": {
                  fill: "#198282",
                },
              }}
            >
              <Link
                href="https://findfaye.com"
                target="_blank"
                underline="none"
              >
                <FayeIcon />
              </Link>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          xs={isMobile ? 6 : 4}
          sx={{ paddingRight: isMobile ? "14px" : "20px" }}
        >
          <Box
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-end",
            }}
          >
            <Button variant={"outlined"} aria-label="Learn more">
              <Link
                href="https://findfaye.com"
                target="_blank"
                underline="none"
              >
                Learn more
              </Link>
            </Button>
          </Box>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Box
            sx={{
              padding: isMobile ? "24px" : "108px 70px",
              paddingTop: "24px",
              height: "calc(100vh - 72px)",
              backgroundColor: "#FFF",
              overflowY: "auto",
            }}
          >
            <DocumentPage isMemberDocument={true} showFullActions={false} />
          </Box>
        </Grid>
      </Grid>
    </GridPage>
  );
};
